export default __webpack_public_path__ + "static/media/light.401bbec7.png";